//Install
import React, { Component } from "react";
//Install
import { Container, Row, Col } from "react-bootstrap";
//Install
import Header from "../../Header";
//Install
import Footer from "../../Footer";
//Install
import Y477FT from "../../../Media/Image/046.jpg";

//Element
class Default extends Component {
    //Element
    componentDidMount() {
        //Element
        document.title = "Yetki Belgeleri : Temas Elektrik Taahhüt"
        //Element
        document.getElementsByTagName("meta")["description"].content = "Her Belge, Temas Elektrik Taahhüt’ün Tecrübeli Kadrosunun ve Deneyimli Mühendisliğinin Bir Göstergesidir."
        //Element
        let URL = "https://temaselektrik.com/yetki-belgeleri"
        //Element
        let Canonical = document.querySelector("link[rel='canonical']")
        //Element
        Canonical.setAttribute("href", URL);
    }
    //Element
    render() {
        //Element
        const Content = React.createElement("div", { className: "website-application" },
            //Element
            React.createElement(Header, {}),
            //Element
            React.createElement("main", { className: "S6pt64 C96Q4r pEO064 a527eB d3c437" },
                //Element
                React.createElement("section", { className: "S6pt64 C96Q4r pEO064 a527eB f1d74t" },
                    //Element
                    React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB p33e0e" },
                        //Element
                        React.createElement("figure", { className: "S6pt64 C96Q4r pEO064 a527eB i457do" })
                    )
                ),
                //Element
                React.createElement("section", { className: "S6pt64 C96Q4r pEO064 a527eB gq620v" },
                    //Element
                    React.createElement(Container, {},
                        //Element
                        React.createElement(Row, {},
                            //Element
                            React.createElement(Col, { md: 12 },
                                //Element
                                React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB v431h7" },
                                    //Element
                                    React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB yk8549" },
                                        //Element
                                        React.createElement("h1", { className: "S6pt64 C96Q4r pEO064 a527eB u7760y" },
                                            //Element
                                            "Yetki Belgeleri"
                                        )
                                    )
                                )
                            ),
                            //Element
                            React.createElement(Col, { md: 6 },
                                //Element
                                React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB q95k0u" },
                                    //Element
                                    React.createElement("h2", { className: "S6pt64 C96Q4r pEO064 a527eB q887o2" },
                                        //Element
                                        "Güvenimizin Temeli ",
                                        //Element
                                        React.createElement("strong", {},
                                            //Element
                                            "Belgelerimizle"
                                        ),
                                        //Element
                                        " Güvence Altında"
                                    ),
                                    //Element
                                    React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB j39v3u" },
                                        //Element
                                        "Temas Elektrik Taahhüt Olarak, Kalite, Güvenlik ve Sürdürülebilirlik Politikamızın Bir Göstergesi Olarak Tüm Hizmetlerimizde Uluslararası Standartlara Entegre Yetki Belgelerine Sahibiz.",
                                    ),
                                    //Element
                                    React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB j39v3u" },
                                        //Element
                                        "Sahip Olduğumuz Sertifikalar :"
                                    ),
                                    //Element
                                    React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB e154zm" },
                                        //Element
                                        "1. ISO 9001:2015 – Kalite Yönetim Sistemi"
                                    ),
                                    //Element
                                    React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB e154zm" },
                                        //Element
                                        "2. OHSAS 18001:2007"
                                    ),
                                    //Element
                                    React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB e154zm" },
                                        //Element
                                        "3. ISO 14001:2015"
                                    ),
                                    //Element
                                    React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB j39v3u" },
                                        //Element
                                        "Bu Belgeler, Müşterilerimize Sunduğumuz Hizmetlerde Mükemmel Kalite, Güven ve Standartları Karşılama Garantisini Temsil Etmektedir. Her belge, Temas Elektrik Taahhüt’ün Profesyonelliğini Doğrulamaktadır."
                                    )
                                )
                            ),
                            //Element
                            React.createElement(Col, { md: 6 },
                                //Element
                                React.createElement("picture", { className: "S6pt64 C96Q4r pEO064 a527eB e649gp" },
                                    //Element
                                    React.createElement("img", { alt: "Yetki Belgeleri", title: "Yetki Belgeleri", src: Y477FT, width: "636", height: "auto" })
                                )
                            )
                        )
                    )
                )
            ),
            //Element
            React.createElement(Footer, {})
        )
        //Element
        return (
            Content
        );
    }
}
//Element
export default Default;